<template>
  <div class="apply">
    <ul>
      <li><span>企业名称</span> <input type="text" v-model="applyForm.company"></li>
      <li><span>联系人</span> <input type="text" v-model="applyForm.person"></li>
      <li><span>手机号码</span> <input type="text" v-model="applyForm.phone"></li>
      <li class="email">
        <p class="email_text"><span>邮箱地址</span> <input type="text" v-model="applyForm.email"></p>
        <button class="send_btn_blue" @click="sendCode()" :disabled="!showCodeBtn" v-show="showCodeBtn">发送验证码
        </button>
        <span v-show="!showCodeBtn" class="send_btn_gray">{{count}} s</span>
        <p class="email_code">验证码 <input type="text" v-model="applyForm.checkCode" placeholder="请输入验证码">
        </p>
      </li>
      <!--上传文件-->
      <li class="file">
        <p class="company_file"><span>企业简介</span> <input type="file" @change="uploadFile($event,0)"><span
            class="choose_file">选择文件</span><span class="file_name">{{fileName0}}</span>
        </p>
        <p class="business_file"><span>商业计划书</span>
          <input type="file" @change="uploadFile($event,1)"> <span class="choose_file">选择文件</span> <span
              class="file_name">{{fileName1}}</span></p></li>
    </ul>
    <div class="submit_apply" @click="submitApply()">
      提交申请
    </div>
  </div>
</template>

<script>
  import axios from '@/server/axios.js'
  import {applyPark, queryQrCode} from '@/api/ApplyPark.js'

  export default {
    data() {
      return {
        //入园申请表单
        applyForm: {
          company: '',
          phone: '',
          person: '',
          email: '',
          checkCode: '',
          companyFile: '',
          businessFile: '',
        },
        fileName0: '',
        fileName1: '',
        showCodeBtn: true,
        count: '',
        timer: null,
        baseUrl: process.env.VUE_APP_BASE_URL
      }
    },
    created() {

    },
    methods: {
      //验证码
      sendCode() {
        queryQrCode(this.applyForm.email).then((res) => {
          if (!this.timer) {
            this.count = 60;
            this.showCodeBtn = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= 60) {
                this.count--;
              } else {
                this.showCodeBtn = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000)
          }
        })
      },
      //提交申请
      submitApply() {
        if (this.applyForm.person === '' || this.applyForm.company === '' || this.applyForm.email === '' || this.applyForm.phone === '' || this.applyForm.companyFile === '' || this.applyForm.businessFile === '' || this.applyForm.checkCode === '') {
          alert('请输入完整数据!')
          console.log(this.applyForm);
        } else {
          applyPark(this.applyForm.person, this.applyForm.company, this.applyForm.email, this.applyForm.phone, this.applyForm.companyFile, this.applyForm.businessFile, this.applyForm.checkCode).then((res) => {
            alert('提交成功!')
          })
        }
      },
      uploadFile(event, item) {
        let fileItem = event.target.files[0]//获取文件
        if (item === 0) {
          this.fileName0 = fileItem.name
        } else if (item === 1) {
          this.fileName1 = fileItem.name
        }

        console.log(fileItem)
        event.preventDefault();//取消默认行为
        let formData = new FormData();
        formData.append('file', fileItem)
        console.log(formData);
        if (fileItem != null) {
          axios.post(this.baseUrl + '/officialWebsite/upload.do', formData).then((res) => {
            if (item === 0) {
              this.applyForm.companyFile = res
            } else if (item === 1) {
              this.applyForm.businessFile = res
            }
          }).catch((error) => {

          })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .apply {
    // $themeColor: #3e76fc;
    ul {
      padding: 30px 0 10px 60px;
      li {
        line-height: 50px;
        span {
          width: 68px;
          display: inline-block;
          margin-right: 30px;
        }
        input {
          width: 580px;
          height: 36px;
          padding-left: 10px;
          border: 1px solid #e5e5e5;
          background-color: #f5f5f5;
        }
      }
      .email {
        display: flex;
        position: relative;
        margin-top: 10px;
        .email_text {
          span {
            width: 68px;
            margin-right: 30px;
          }
          input {
            width: 340px;
          }
        }
        .send_btn_blue {
          width: 86px;
          height: 36px;
          line-height: 34px;
          text-align: center;
          border: none;
          background-color: $themeColor;
          font-size: 14px;
          color: #fff;
          position: absolute;
          left: 50%;
          top: 9px;
          cursor: pointer;
        }
        .send_btn_gray {
          width: 86px;
          height: 36px;
          line-height: 38px;
          text-align: center;
          background-color: #666;
          font-size: 14px;
          color: #fff;
          position: absolute;
          left: 50%;
          top: 9px;
        }
        .email_code {
          margin-left: 38px;
          input {
            width: 150px;
          }
        }
      }
      .file {
        height: 60px;
        display: flex;
        margin-top: 10px;
        p {
          position: relative;
          span {
            width: 80px;
          }
          .choose_file {
            width: 80px;
            height: 30px;
            display: inline-block;
            line-height: 30px;
            text-align: center;
            position: absolute;
            top: 10px;
            left: 98px;
            font-size: 14px;
            color: #fff;
            border-radius: 2px;
            background-color: gray;
          }
          .file_name {
            width: 150px;
            height: 30px;
            display: inline-block;
            line-height: 30px;
            position: absolute;
            top: 10px;
            left: 190px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        input {
          width: 240px;
          border: none;
          background-color: #fff;
          cursor: pointer;
          position: relative;
          top: 0;
          left: -22px;
          opacity: 0;
          z-index: 2;
          color: transparent;
        }
      }
    }
    .submit_apply {
      width: 130px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      color: #fff;
      background-color: $themeColor;
      border-radius: 20px;
      position: absolute;
      left: 326px;
      bottom: 30px;
      cursor: pointer;
    }
  }
</style>
